import React from "react";
import { Typography } from "design_system/src";
import motoLoading from "../static/gifs/loading_moto.gif";


export const LoadingScreen = () => (
  <div className="dim_100_vp display_flex flex_center flex_col">
    <img src={motoLoading} alt="" className="h_xxxl" />
    <Typography scale="large" weight="600" className="text_center">Cargando...</Typography>
  </div>
);
